import { css } from '@emotion/react'
import { Slider } from '@mui/material'

const DEFAULT_SLIDER_MARKS = [
  {
    value: 0,
    label: '0',
  },
  {
    value: 10,
  },
  {
    value: 20,
  },
  {
    value: 30,
  },
  {
    value: 40,
  },
  {
    value: 50,
  },
  {
    value: 60,
  },
  {
    value: 70,
  },
  {
    value: 80,
  },
  {
    value: 90,
  },
  {
    value: 100,
    label: '100',
  },
]

const thresholdTitle = css`
  margin: 0;
  font-size: 11px;
  color: #00000061;
`

interface AiThresholdSelectorProps {
  sliderMarks?: {
    value: number
    label?: string
  }[]
  title: string
  value?: number
  onChange?: (value: number) => void
  onChangeCommitted?: (value: number) => void
}

export const AiThresholdSelector = ({
  sliderMarks = DEFAULT_SLIDER_MARKS,
  title,
  value = 80,
  onChangeCommitted,
  onChange,
}: AiThresholdSelectorProps) => {
  return (
    <div>
      <p css={thresholdTitle}>{title}</p>
      <div css={{ position: 'relative', padding: '0 5px', maxWidth: '165px' }}>
        <Slider
          aria-label={title}
          key={`creative-ai-treshold-selector-${title}`}
          size="small"
          onChange={(_, newValue) => onChange?.(newValue[0] as number)}
          onChangeCommitted={(_, newValue) => onChangeCommitted?.(newValue[0] as number)}
          defaultValue={[value, 100]}
          sx={{ color: '#7F52FF' }}
          marks={sliderMarks}
          value={[value, 100]}
          min={0}
          max={100}
          valueLabelDisplay="auto"
        />
      </div>
    </div>
  )
}
